import * as THREE from 'three';

// Spectrum skin color palette - neutral dark theme that works with all block colors
export const SPECTRUM_COLORS = {
  primary: '#3A4A5A',      // Neutral blue-gray for grid/borders
  secondary: '#FFFFFF',    // White highlights
  emissive: '#4A5A6A',     // Subtle gray-blue glow
  background: '#0a0a12',   // Very dark blue-black
  accent: '#7A8A9A',       // Neutral gray for effects
  gridLine: '#0d0f15',     // Barely visible grid lines
};

// Vibrant tetromino colors - matching the 2D theme but more saturated for 3D
export const TETROMINO_COLORS = {
  'l-tetromino-active': '#FF8C00',      // Bright Orange (L)
  'j-tetromino-active': '#4169FF',      // Bright Blue (J)
  't-tetromino-active': '#9B30FF',      // Bright Purple (T)
  'square-tetromino-active': '#FFD700', // Bright Yellow/Gold (O)
  'line-tetromino-active': '#00CED1',   // Deep Cyan/Teal (I) - distinct from white
  'z-tetromino-active': '#FF3030',      // Bright Red (Z)
  's-tetromino-active': '#32CD32',      // Bright Green (S)
};

// Emissive colors for glow effect
export const TETROMINO_EMISSIVE = {
  'l-tetromino-active': '#FF6000',
  'j-tetromino-active': '#2040FF',
  't-tetromino-active': '#8000FF',
  'square-tetromino-active': '#FFAA00',
  'line-tetromino-active': '#009999',
  'z-tetromino-active': '#FF0000',
  's-tetromino-active': '#00AA00',
};

// Get block color based on tetromino type
export const getBlockColor = (colorClass) => {
  return TETROMINO_COLORS[colorClass] || SPECTRUM_COLORS.primary;
};

// Get emissive color for glow
export const getEmissiveColor = (colorClass) => {
  return TETROMINO_EMISSIVE[colorClass] || SPECTRUM_COLORS.emissive;
};

// Create a Spectrum-styled material for blocks
export const createSpectrumMaterial = (options = {}) => {
  const {
    color = SPECTRUM_COLORS.primary,
    emissive = SPECTRUM_COLORS.emissive,
    emissiveIntensity = 0.5,
    metalness = 0.3,
    roughness = 0.4,
    opacity = 1.0,
    transparent = false,
  } = options;

  return new THREE.MeshStandardMaterial({
    color: new THREE.Color(color),
    emissive: new THREE.Color(emissive),
    emissiveIntensity,
    metalness,
    roughness,
    opacity,
    transparent,
  });
};

// Create ghost (hard drop preview) material
export const createGhostMaterial = (baseColor) => {
  return new THREE.MeshStandardMaterial({
    color: new THREE.Color(baseColor),
    emissive: new THREE.Color(baseColor),
    emissiveIntensity: 0.3,
    metalness: 0.2,
    roughness: 0.5,
    opacity: 0.4,
    transparent: true,
  });
};

// Create edge highlight material
export const createEdgeMaterial = () => {
  return new THREE.LineBasicMaterial({
    color: 0xffffff,
    linewidth: 2,
    opacity: 0.6,
    transparent: true,
  });
};

// Theme configuration
export const THEME_CONFIG = {
  name: 'Spectrum',
  background: '#0a0a12',
  bloomIntensity: 0.6,
  bloomThreshold: 0.15,
  vignetteOffset: 0.3,
  vignetteDarkness: 0.4,
};
